import { DepartureCityId } from '@/entities/departureCity';

export const ALTERNATIVE_DEPARTURE_CITY_IDS: readonly DepartureCityId[] = [
  DepartureCityId.Moscow,
  DepartureCityId.SaintPetersburg,
  DepartureCityId.Ekaterinburg,
  DepartureCityId.Kazan,
  DepartureCityId.Novosibirsk,
  DepartureCityId.Samara,
];

export const ALTERNATIVE_SEARCH_FLEXIBLE_DAYS = 3;
